export const SLIDER_CONFIRMED_PREFIX = '[slider-confirmed]';

export interface SliderConfirmedPayload {
    responseKey: string;
    /** The chosen numeric value in the widget's own unit (e.g. dollars). */
    value: number;
}

export const buildSliderConfirmedAgentMessage = ({
    displayText,
    payload,
}: {
    displayText: string;
    payload: SliderConfirmedPayload;
}): string =>
    `${displayText}\n${SLIDER_CONFIRMED_PREFIX} ${JSON.stringify(payload)}`;

export const stripSliderMachineLine = (message: string): string => {
    const prefixIndex = message.indexOf(SLIDER_CONFIRMED_PREFIX);
    if (prefixIndex === -1) {
        return message;
    }

    return message.slice(0, prefixIndex).trimEnd();
};

export const parseSliderConfirmedMessage = (
    text: string,
): SliderConfirmedPayload | null => {
    const prefixIndex = text.indexOf(SLIDER_CONFIRMED_PREFIX);
    if (prefixIndex === -1) {
        return null;
    }

    const jsonPayload = text
        .slice(prefixIndex + SLIDER_CONFIRMED_PREFIX.length)
        .trim();

    try {
        const parsed: unknown = JSON.parse(jsonPayload);
        if (
            typeof parsed !== 'object' ||
            parsed == null ||
            typeof (parsed as SliderConfirmedPayload).responseKey !==
                'string' ||
            typeof (parsed as SliderConfirmedPayload).value !== 'number'
        ) {
            return null;
        }

        return parsed as SliderConfirmedPayload;
    } catch {
        return null;
    }
};

/** Returns the member-visible text for a stored slider confirmation message. */
export const formatSliderUserMessageForDisplay = (text: string): string => {
    if (!text.includes(SLIDER_CONFIRMED_PREFIX)) {
        return text;
    }

    return stripSliderMachineLine(text);
};
